import React from 'react';
import './UserRow.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function UserRow({ showDetail, user }) {
  if (logComponent('UserRow')) { console.debug('UserRow rendered'); }

  const handleButtonClick = () => {
    if (logComponent('UserRow')) { console.debug('UserRow handleButtonClick'); }
    showDetail(user);
  }

  return (
    <tr className="User-Row">
      <td className="User-Row__cell User-Row__name-cell">
        <span className="User-Row__name">{user.legalFirstName} {user.lastName}
          {
            user.canCorrespond &&
            <FontAwesomeIcon
              className="User-Row__comment-icon"
              icon="comment"></FontAwesomeIcon>
          }
          {
            user.hasImpersonateViaGroupsOrOverride &&
            <FontAwesomeIcon
              className="User-Row__eye-icon"
              icon="eye"></FontAwesomeIcon>
          }
        </span>
        <span className="User-Row__email">{user.emailAddress}</span>
      </td>
      <td className="User-Row__cell User-Row__role-cell">{user.isAdmin ? 'Admin' : 'Standard'}</td>
      <td className="User-Row__cell User-Row__status-cell">{user.status}</td>
      <td className="User-Row__cell">
        <button
          className="User-Row__icon-btn"
          onClick={handleButtonClick}>
          <FontAwesomeIcon icon="ellipsis-h"></FontAwesomeIcon>
        </button>
      </td>
    </tr>
  );
}